export default __webpack_public_path__ + "static/media/logo-3d-ovato-logo-new.7c93ed45.png";